
import axios from 'axios'

import router from '@/router/index';
import store from '@/store/index';


/*headers: {
  'Content-Type': 'application/json'
http://localhost:8001/    local DOCKER
  http://localhost:8000/  local Normal.
  http://185.254.204.241:8001/    production VPS

  https://teczoa.com/    //production ultimate


}*/

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://teczoa.com/',
  'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
});

http.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  config.headers.Authorization = token ? `Bearer ${token}` : '';

  return config;
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('Error en la peticion, se necesita login', error);

  // Si la petición marcó skipAuthInterceptor, no aplicar lógica global de 401
  // (el componente manejará el error directamente, ej: CarritoCompra muestra LoginCarrito)
  const skipAuth = error.config && error.config.skipAuthInterceptor;

  if (error.response && error.response.status === 401 && !skipAuth) {
    store.commit('vaciarCarrito');
    store.commit('setLogueado', false);
    router.push('/login').catch(() => {});
  }

  if (error.response && error.response.status === 500 && !skipAuth) {
    router.push('/login').catch(() => {});
  }

  return Promise.reject(error);
});
